import pick from 'lodash/pick';
import {
  StopRegistryPrivateCodeInput,
  StopRegistryQuay,
  StopRegistryQuayInput,
} from '../../../generated/graphql';
import { EnrichedQuay } from '../../../types';
import {
  mapAccessibilityAssessmentToInput,
  mapAlternativeNames,
  mapExternalLinks,
  mapGeoJsonToInput,
  mapOrganisations,
  mapPlaceEquipmentsToInput,
  omitTypeName,
} from './copyEntityUtilities';
import { decodeQuayPrivateCodeType } from './decodeQuayPrivateCodeType';

function isEnrichedQuay(
  quay: StopRegistryQuay | EnrichedQuay,
): quay is EnrichedQuay {
  return (quay as StopRegistryQuay).privateCode?.value === undefined;
}

function getQuayPrivateCode(
  quay: StopRegistryQuay | EnrichedQuay | null | undefined,
): StopRegistryPrivateCodeInput | null {
  if (!quay?.privateCode) {
    return null;
  }

  if (isEnrichedQuay(quay)) {
    return {
      value: quay.privateCode ?? '',
      type: decodeQuayPrivateCodeType(quay.privateCode),
    };
  }

  if (!quay.privateCode?.value) {
    return null;
  }

  return omitTypeName(quay.privateCode) as StopRegistryPrivateCodeInput;
}

export function mapQuayToInput(
  quay: Omit<EnrichedQuay | StopRegistryQuay, 'scheduled_stop_point'>,
): StopRegistryQuayInput {
  return {
    ...pick(quay, ['compassBearing', 'publicCode']),
    description: omitTypeName(quay.description),
    alternativeNames: mapAlternativeNames(quay.alternativeNames),
    accessibilityAssessment: mapAccessibilityAssessmentToInput(
      quay.accessibilityAssessment,
    ),
    geometry: mapGeoJsonToInput(quay.geometry),
    placeEquipments: mapPlaceEquipmentsToInput(quay.placeEquipments),
    externalLinks: mapExternalLinks(quay.externalLinks),
    privateCode: getQuayPrivateCode(quay),
    keyValues: quay.keyValues?.map((kv) => omitTypeName(kv)),
    organisations: mapOrganisations(quay.organisations),
  };
}
